import { EmailType } from '@business/constants/emailtype';
import { CompactOrgResponse, CompactOrgSmallResponse, OrgResponse } from '@business/entities/organization';
import { ContactService } from '@business/services';
import { useObservable } from '@core/utils/hooks/rxjs';
import { Session } from '@modules/auth/session';
import { openNewEmailModal } from '@modules/notes/TabEmail/NewEmailModal';
import React, { Fragment, memo, useMemo } from 'react';
import { Badge } from 'reactstrap';

export interface ContactEmailTextProps {
  org: OrgResponse | CompactOrgResponse | CompactOrgSmallResponse;
  email: string;
  type?: EmailType;
}

export const ContactEmailText = memo((props: ContactEmailTextProps) => {
  const { org, email, type } = props;
  const user = useObservable(Session.user$);

  const emailText = useMemo(() => {
    return (
      <>
        {email}
        {type && (
          <Badge color={ContactService.getTypeColor(type)} className="ml-2">
            {type}
          </Badge>
        )}
      </>
    );
  }, [email, type]);

  if (!user?.socialAccounts.length) {
    return <Fragment>{emailText}</Fragment>;
  }

  return (
    <a className="d-flex flex-row " onClick={() => openNewEmailModal({ org, email })}>
      {emailText}
    </a>
  );
});
